export default {
    computed: {
        headers() {
            return [
                {
                    value: 'id',
                    text: this.$t('labels.id'),
                    type: 'string',
                },
                {
                    value: 'name',
                    text: this.$t('labels.name'),
                    type: 'string',
                },
                {
                    value: 'fhrsRating',
                    text: this.$t('labels.fhrs_rating'),
                    type: 'string',
                },
                {
                    value: 'thirdPartyDifferences',
                    text: this.$t('labels.third_party_differences'),
                },
                {
                    value: 'isEnabledForRestaurantAdmin',
                    text: this.$t('labels.list_restaurant_admin'),
                },
                {
                    value: 'isActive',
                    text: this.$t('labels.active'),
                },
            ]
        },
    },
}
